import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface PartnerReportRow {
  partner_id: string;
  branding_title: string;
  legal_name: string;
  // Outbound (we → them)
  shop_impressions: number;
  shop_detail_opens: number;
  partner_clickouts: number;
  unique_users_reached: number;
  purchases: number;
  redemptions: number;
  // Inbound (they → us)
  scan_events: number;
  unique_scan_sessions: number;
  signups: number;
  paying_conversions: number;
}

export function usePartnerReport(periodDays: number) {
  const query = useQuery({
    queryKey: ["partner-report", periodDays],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase.rpc as any)("partner_report", {
        p_period_days: periodDays,
      });
      if (error) throw error;
      return (data as PartnerReportRow[]) ?? [];
    },
    enabled: !!periodDays,
    staleTime: 5 * 60_000,
  });

  return {
    data: query.data,
    rows: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
